export const GET_PRICE_UNIT = '[Price Unit Action] Get Price Unit';
export const CONFIRMED_GET_PRICE_UNIT = '[Price Unit Action] Confirmed Get Price Unit';
